<app-header-search headerText="User accounts" />

<div class="users-toolbar">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search by name or email</mat-label>
    <input matInput [formControl]="searchControl" />
  </mat-form-field>
  <label class="admins-only-toggle">
    <input type="checkbox" [checked]="adminsOnly" (change)="toggleAdminsOnly()" />
    Administrators only
  </label>
</div>

@if (loading) {
  <p>Loading users…</p>
} @else if (error) {
  <p class="error">{{ error }}</p>
} @else if (!users.length) {
  <p>No users found.</p>
} @else {
  <table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Roles</th>
        <th>Admin</th>
        <th>Verified</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (user of users; track user.id) {
        <tr>
          <td>{{ user.fullName || '—' }}</td>
          <td>{{ user.email }}</td>
          <td>{{ roleLabel(user) }}</td>
          <td>{{ adminLabel(user) }}</td>
          <td>{{ validatedLabel(user) }}</td>
          <td class="actions-cell">
            @if (!isCurrentUser(user)) {
              <button
                type="button"
                class="remove-user-btn"
                [disabled]="removingUserId === user.id"
                (click)="confirmRemoveUser(user)"
              >
                Remove
              </button>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
  <p class="users-count">{{ total }} account{{ total === 1 ? '' : 's' }}</p>
}
